import { render, staticRenderFns } from "./PlacementsEndComponentReviewAdmin.vue?vue&type=template&id=f5ec3680&"
import script from "./PlacementsEndComponentReviewAdmin.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentReviewAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports